// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d91d178","239":"88feeb75","455":"1a5032fe"}[chunkId] + ".chunk.js";
};